import "./selection/index.js";
export { default as transition } from "./transition/index.js";
export { default as active } from "./active.js";
export { default as interrupt } from "./interrupt.js";


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-transition@1.3.2@d3-transition/src/index.js
// module id = 457
// module chunks = 0